// extracted by mini-css-extract-plugin
export default {"rating":"nJ-z","numberOfStars":"oJ-z","count":"pJ-z","barGraphSpacing":"qJ-z","barGraph":"rJ-z"};